import React from 'react';
import {
  addCustomerUserFormValues,
  useAddCustomerUserForm,
} from './hooks/useAddCustomerUserForm';
import { S } from './AddCustomerUserForm.styles';
import { Button } from '@ansvar-sakerhet/ui/src/buttons/Button';
import { CreateCustomerUserDto } from '@ansvar-sakerhet/api-client';
import { useCreateCustomerUser } from '../../../../../../../../../../../traits/api/customerUsers/useCreateCustomerUser';
import { Input } from '../../../../../../../../../../../components/Input';
import { ProjectAccessFields } from '../ProjectAccessFields';

export const AddCustomerUserForm = ({
  chosenClientId,
  onCancel,
}: {
  chosenClientId: string;
  onCancel: () => void;
}) => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useAddCustomerUserForm({
    defaultClientId: chosenClientId,
  });
  const { mutateAsync } = useCreateCustomerUser();

  const hasAllProjectAccess = watch('hasAllProjectAccess');
  const projectIds = watch('projectIds');

  const onSubmit = async (data: addCustomerUserFormValues) => {
    const formattedData: CreateCustomerUserDto = {
      email: data.email,
      password: data.password,
      firstName: data.firstName,
      lastName: data.lastName,
      hidden: data.hidden,
      clientIds: [data.clientId],
      hasAllProjectAccess: data.hasAllProjectAccess,
      ...(data.hasAllProjectAccess ? {} : { projectIds: data.projectIds }),
    };
    await mutateAsync(formattedData);
    onCancel();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <S.Container>
        <Input label="E-post" error={errors.email} {...register('email')} />
        <Input
          label="Lösenord"
          type="password"
          autoComplete="new-password"
          error={errors.password}
          {...register('password')}
        />
        <Input
          label="Förnamn"
          error={errors.firstName}
          {...register('firstName')}
        />
        <Input
          label="Efternamn"
          error={errors.lastName}
          {...register('lastName')}
        />

        <Input
          label={'Dölj personen'}
          style={{ height: 20, float: 'left' }}
          type="checkbox"
          {...register('hidden')}
        />

        <ProjectAccessFields
          clientId={chosenClientId}
          hasAllProjectAccess={hasAllProjectAccess}
          selectedProjectIds={projectIds}
          onHasAllProjectAccessChange={(value) =>
            setValue('hasAllProjectAccess', value, { shouldValidate: true })
          }
          onSelectedProjectIdsChange={(ids) =>
            setValue('projectIds', ids, { shouldValidate: true })
          }
        />
        {errors.projectIds && (
          <S.ErrorText>{errors.projectIds.message}</S.ErrorText>
        )}

        <S.Flex $justify="between" $gap={16} $flexDir="row">
          <Button $outlined type="button" onClick={onCancel}>
            Avbryt
          </Button>
          <Button type="submit">Spara</Button>
        </S.Flex>
      </S.Container>
    </form>
  );
};
